import type React from 'react';

export interface BorderedListItem {
  id: string;
  title: string;
  description: string;
}

interface BorderedListSectionProps {
  title: string;
  subtitle: string;
  items: BorderedListItem[];
}

/**
 * 左侧竖线列表展示模块：H2 标题 + 副标题 + 带左边框的若干 H3 条目。
 * 供 Prompt Formula、Use Cases 等结构一致的内容区块复用。
 */
export const BorderedListSection: React.FC<BorderedListSectionProps> = ({ title, subtitle, items }) => {
  return (
    <section className="pt-[120px] sm:pt-10">
      <div className="mx-auto w-[58vw] px-4 sm:w-full">
        <h2 className="font-semibold text-[40px] leading-tight sm:text-[32px]">{title}</h2>
        <p className="mt-4 text-base text-white/60 leading-[1.6] sm:text-sm">{subtitle}</p>
        <div className="mt-12 flex flex-col gap-10 border-white/25 border-l-[3px] pl-10 sm:mt-8 sm:gap-6 sm:pl-6">
          {items.map((item) => (
            <div key={item.id}>
              <h3 className="mb-3 font-semibold text-xl leading-[1.3] sm:text-lg">{item.title}</h3>
              <p className="whitespace-pre-line text-base text-white/60 leading-[1.6] sm:text-sm">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
